import { Navbar } from "@/components/sections/Navbar";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { Services } from "@/components/sections/Services";
import { Portfolio } from "@/components/sections/Portfolio";
import { JayWorking } from "@/components/sections/JayWorking";
import { Testimonials } from "@/components/sections/Testimonials";
import { Booking } from "@/components/sections/Booking";
import { Footer } from "@/components/sections/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Services />
      <Portfolio />
      <JayWorking />
      <Testimonials />
      <Booking />
      <Footer />
    </main>
  );
}
